import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';

import CustomSelect from 'components/CustomSelect';
import Pagination from 'components/Pagination';
import FilterSearch from 'components/FilterSearch';
import FilterDropdown from 'components/FilterDropdown';
import DatePicker from 'react-datepicker';

import { GET, httpOk, PATCH } from 'helpers/api';
import { formatDate, handleDateChange } from 'helpers/helpers';
import Detail from 'pages/buyer/modals/Detail';

function Warehouse() {
	const { t } = useTranslation()
	const priorities = [
		{
			id: 'high',
			name: t('high')
		},
		{
			id: 'normal',
			name: t('normal')
		},
		{
			id: 'low',
			name: t('low')
		},
	];

	const statuses = [
		{
			id: 'draft',
			name: t('draft')
		},
		{
			id: 'submitted',
			name: t('awaiting_buyer')
		},
		{
			id: 'approved',
			name: t('awaiting_delivery')
		},
		{
			id: 'rejected',
			name: t('rejected')
		},
		{
			id: 'closed',
			name: t('received')
		},
	];

	const [dropdown, setDropdown] = useState(false)
	const [detailModal, setDetailModal] = useState({ show: false, item: {} })

	const initFilterData = {
		page: 1,
		page_size: 20,
		search: '',
		status: '',
	}

	const [filterData, setFilterData] = useState(initFilterData)

	const [data, setData] = useState({})

	async function acceptRequest(item) {
		const response = await PATCH(`/procurement/requests/${item.id}/receive/`, { received: true })
		if (httpOk(response)) {
			getData();
		}
	}

	const handlePaginate = (args) => {
		setFilterData(prev => ({
			...prev,
			page: args.page + 1,
			page_size: args.page_size
		}));
	};

	const getData = useCallback(async () => {
		const response = await GET('/procurement/requests/', filterData);

		if (httpOk(response)) {
			setData(response.data);
		}
	}, [filterData]);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<>
			<div className="d-between">
				<div>
					<div className="main-content-title">
						{t('my_purchase_requests')}
					</div>

					<div className="main-content-subtitle">
						{t('raw_material_procurement_management')}
					</div>
				</div>
			</div>

			<div className="card">
				<div className="d-flex gap-16 w-100">
					<FilterSearch
						value={filterData.search}
						onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
						placeholder={t('search_by_name')}
					/>

					<CustomSelect
						options={statuses}
						value={statuses.find(option => option.id === filterData?.status) || ''}
						onChange={(option) => setFilterData({ ...filterData, status: option?.id })}
						getOptionLabel={(option) => option.name}
						getOptionValue={(option) => option.id}
						placeholder={t('select_status')}
					/>

					<FilterDropdown dropdown={dropdown} setDropdown={setDropdown}>
						<div className="form-group">
							<label htmlFor="name">{t('priority')}</label>
							<CustomSelect
								options={priorities}
								value={priorities.find(option => option.id === filterData?.priority) || ''}
								onChange={(option) => setFilterData({ ...filterData, priority: option?.id })}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="d-flex gap-8">
							<div className="form-group">
								<label htmlFor="name">{t('date_from')}</label>
								<DatePicker
									selected={filterData.date_from ? new Date(filterData.date_from) : null}
									onChange={(date) => setFilterData(handleDateChange(date, 'date_from', filterData))}
									dateFormat="yyyy-MM-dd"
									placeholderText={t('select_date')}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="name">{t('date_to')}</label>
								<DatePicker
									selected={filterData.date_to ? new Date(filterData.date_to) : null}
									onChange={(date) => setFilterData(handleDateChange(date, 'date_to', filterData))}
									dateFormat="yyyy-MM-dd"
									placeholderText={t('select_date')}
								/>
							</div>
						</div>
					</FilterDropdown>
				</div>
			</div>

			<div className="card">
				<div className="d-between mb-30">
					<div className="fz16 text-third">
						{t('my_requests')}
					</div>
				</div>

				<table className="table">
					<thead>
						<tr>
							<th style={{ width: '10%' }}>{t('date')}</th>
							<th style={{ width: '20%' }}>{t('supplier')}</th>
							<th style={{ width: '20%' }}>{t('procurement')}</th>
							<th style={{ width: '10%' }}>{t('priority')}</th>
							<th style={{ width: '10%' }}>{t('status')}</th>
							<th style={{ width: '15%' }}>{t('actions')}</th>
						</tr>
				</thead>

					<tbody>
						{data?.results?.map((item, index) => (
							<tr key={index}>
								<td>{formatDate(item.created_at)}</td>
								<td>{item.supplier_name}</td>
								<td>{item.procurement_user_name}</td>
								<td>
									<div className={`alert alert-${item.priority} w-fit-content`}>
										{t(item.priority)}
									</div>
								</td>
								<td>
									<div className={`alert alert-${item.status} w-fit-content`}>
										{t(item.status)}
									</div>
								</td>
								<td>
									<div className="d-flex align-items-center gap-8">
										<button className="transparent small" onClick={() => setDetailModal({ show: true, item })}>
											{t('details')}
										</button>
										{item.status === 'approved' &&
											<button className="white small" onClick={() => acceptRequest(item)}>
												<CheckIcon />
												{t('received_btn')}
											</button>
										}
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>

				<Pagination
					paginate={handlePaginate}
					pagination={{
						total: data?.count || 0
					}}
				/>
			</div>

			<Detail modal={detailModal.show} setModal={() => setDetailModal({ show: false })} item={detailModal.item} showTotal={false} />
		</>
	)
}

export default Warehouse